export const required = <T>(value: T | null | undefined): T => {
  if (value === null || value === undefined) {
    throw new Error('Value is null or undefined')
  }

  return value
}

export const buildObjectFromKeys =
  <TValue, TKey extends string[]>
  (buildValue: (key: TKey[number]) => TValue, ...keys: [...TKey]): { readonly [p in TKey[number]]: TValue } => {
    const mappedKeys = keys.map(key => [key, buildValue(key)] as const) satisfies Array<readonly [TKey[number], TValue]>

    // Asserting is required to preserve the TKey, instead of widening it to string
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    return Object.fromEntries(mappedKeys) as { readonly [p in TKey[number]]: TValue }
  }